import React from 'react';
import { connect } from 'react-redux';


class SmallAnnouncementCard extends React.Component {
  constructor(props) {
    super(props);


    // used by React as the component name
    this.displayName = 'SmallAnnouncementCard';
  }


  /**
   * Renders component
   * @returns {ReactElement} ReactElement
   */
  render() {
    const data = this.props.data;
    const state = this.props.smallCardFrameworkState;
    const activeClass = ((state.currentCardIteration + 1) === data.order) ?
      ' active' : '';
    const className = 'card component-small-announcement-card' + activeClass;

    return (
      <section
        className={className}
        style={this.props.style}
      >
        <img src={data.imagePath} alt='Bleacher Report' />
        <div
          className='text'
          dangerouslySetInnerHTML={{ __html: data.text }}
        />
        <a
          className='cta'
          href={data.clickThroughUrl}
        >
          {data.cta}
        </a>
      </section>
    );
  }
}


/**
 * Expected propTypes
 * @prop {Object} data - An array of card React components
 * @prop {Number} height - A height for the card
 * @prop {String} position - A position for the quote, can be 'top' or 'bottom'
 * @prop {Object} smallCardFrameworkState - The state of the
 * SmallCardFramework component
 * @prop {Object} style - A style object
 */
SmallAnnouncementCard.propTypes = {
  data: React.PropTypes.object.isRequired,
  height: React.PropTypes.number,
  position: React.PropTypes.string,
  smallCardFrameworkState: React.PropTypes.object.isRequired,
  style: React.PropTypes.object,
};


export default connect(({ mediaLabCardFrameworkState, smallCardFrameworkState }) =>
  ({ mediaLabCardFrameworkState, smallCardFrameworkState }))(SmallAnnouncementCard);



/** WEBPACK FOOTER **
 ** ./assets/js/src/components/cards/small/SmallAnnouncementCard.jsx
 **/